import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ErrorBoundary } from './components/ErrorBoundary'
import HomePage from './pages/Home'
import AboutPage from './pages/About'
import ProgramsPage from './pages/Programs'
import TrainersPage from './pages/Trainers'
import NutritionPage from './pages/Nutrition'
import PricingPage from './pages/Pricing'
import ContactPage from './pages/Contact'
import FaqPage from './pages/Faq'
import ParkClassesPage from './pages/ParkClasses'
import LoginPage from './pages/Login'
import SignupPage from './pages/Signup'
import DashboardPage from './pages/Dashboard'
import AdminDashboardPage from './pages/dashboard/AdminDashboard'
import TrainerDashboardPage from './pages/dashboard/TrainerDashboard'
import ClientDashboardPage from './pages/dashboard/ClientDashboard'
import BookingsPage from './pages/Bookings'
import TrainerDiscoveryPage from './pages/TrainerDiscovery'
import TrainerProfilePage from './pages/TrainerProfile'
import TrainerBookingPage from './pages/TrainerBooking'
import NutritionistDiscoveryPage from './pages/NutritionistDiscovery'
import NutritionistProfilePage from './pages/NutritionistProfile'
import NutritionistBookingPage from './pages/NutritionistBooking'
import ProfilePage from './pages/Profile'
import TrainerApplicationPage from './pages/TrainerApplication'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/trainers" element={<TrainersPage />} />
          <Route path="/nutrition" element={<NutritionPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/park-classes" element={<ParkClassesPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/trainer"
            element={
              <ProtectedRoute allowedRoles={['trainer']}>
                <TrainerDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/client"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <ClientDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute>
                <BookingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          
          {/* Trainer Discovery & Booking */}
          <Route path="/trainer-discovery" element={<TrainerDiscoveryPage />} />
          <Route path="/trainer/:id" element={<TrainerProfilePage />} />
          <Route
            path="/trainer/:id/book"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <TrainerBookingPage />
              </ProtectedRoute>
            }
          />
          
          {/* Nutritionist Discovery & Booking */}
          <Route path="/nutritionist-discovery" element={<NutritionistDiscoveryPage />} />
          <Route path="/nutritionist/:id" element={<NutritionistProfilePage />} />
          <Route
            path="/nutritionist/:id/book"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <NutritionistBookingPage />
              </ProtectedRoute>
            }
          />
          
          {/* Trainer Application */}
          <Route
            path="/become-trainer"
            element={
              <ProtectedRoute allowedRoles={['client']}>
                <TrainerApplicationPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  )
}

export default App

